import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-28/task-02";

const task: Slide = {
  titleHtml: `Take a look at this building construction with vibration isolation lining in the source room. Note all the different<br />
  paths of sound vibrations from the source room to the receiving room. The paths attenuated with the vibration<br />lining
  are marked green, and the ones that are not attenuated are marked red. Choose the image<br />
  that correctly displays the effects of the vibration isolation lining.`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
